import { defineStore } from 'pinia'

export const useUpdateStore = defineStore('useUpdateStore', {
  state: () => {
    return {
      v: false,
    }
  },
  actions: {
    show() {
      this.v = true
    },
    hidden() {
      this.v = false
    },
  },
  getters: {
    visible: (state) => state.v,
  },
})
